import { SpinResponse } from '@cgs/data-access';
import { CgsEvent } from '@cgs/wge';
import { BuyFreeSpinsEvent } from '../../events/BuyFreeSpinsEvent';
import { ResponseHolder } from '../../response_holder';
import { BaseGameState } from '../../states/base_game_state';
import { InterruptStateRule } from './interrupt_state_rule';

export class BuyFreeSpinsRule<
  TResponse extends SpinResponse,
> extends InterruptStateRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  eventTest(event: CgsEvent): boolean {
    return event instanceof BuyFreeSpinsEvent;
  }

  ruleCondition(_responseHolder: ResponseHolder<TResponse>): boolean {
    return true;
  }
}
